import React, { useEffect, useState } from "react";
import axios from "../../api/axios.js";
import {
  convertIntoSelect2Options,
  customConvertIntoSelect2OptionsClasses,
  getFetchOptions,
} from "../../js/utility.js";
import Breadcrumb from "../utils/Breadcrumb.jsx";
import Select from "react-select";
import { useLocation } from "react-router-dom";

const StudentsLayout = () => {
  const [students, setStudents] = useState([]);
  const [provsOption, setProvsOption] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [classOption, setClassOption] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [isImportEnabled, setIsImportEnabled] = useState(false);

  const [teacherSchools, setTeacherSchools] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const currentMonth = new Date().getMonth();
  const schoolYear =
    currentMonth >= 8
      ? `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
      : `${new Date().getFullYear() - 1}${new Date().getFullYear()}`;

  const role = localStorage.getItem("role");
  const teacherId = localStorage.getItem("userId");

  let loadedData = false;

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();

  const breadcrumb = {
    current_section: "Gestione Studenti",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Gestione studenti", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllSchools`,
          fetchOptions
        );
        const result = await response.json();

        const customresult = result.map((item) => {
          return {
            ...item,
            customTown: item.Town.nome + " (" + item.Province.codice + ")",
          };
        });

        setSchoolOptions(
          convertIntoSelect2Options(customresult, "id", [
            "codmiur",
            "denomistituto",
            "customTown",
          ])
        );
      } catch (error) {
        console.error(error);
      }
    };
    const fetchTeacherSchools = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getTeacherSchools?userId=${teacherId}`,
          fetchOptions
        );
        const result = await response.json();

        const customresult = result.map((item) => {
          return {
            ...item,
            customTown: item.Town.nome + " (" + item.Province.codice + ")",
          };
        });

        setSchoolOptions(
          convertIntoSelect2Options(customresult, "id", [
            "codmiur",
            "denomistituto",
            "customTown",
          ])
        );
      } catch (error) {
        console.error(error);
      }
    };

    if (role === "Admin") fetchSchools();
    if (role === "Insegnante") fetchTeacherSchools();

    loadedData = true;
  }, []);

  useEffect(() => {
    const schoolIdFromUrl = query.get("schoolId");
    const classIdFromUrl = query.get("classId");

    if (schoolIdFromUrl) {
      setSelectedSchool(schoolIdFromUrl);
      handleSchoolChangeFromUrl(schoolIdFromUrl);
    } else {
      setSelectedSchool(null);
    }

    if (classIdFromUrl) {
      setSelectedClass(classIdFromUrl);
      handleSearch(classIdFromUrl);
    } else {
      setSelectedClass(null);
    }
  }, [loadedData]);

  useEffect(() => {
    if (role === "insegnante") {
      setSchoolOptions(
        schoolOptions.filter((school) =>
          teacherSchools.some((ts) => ts.idscuola === school.value)
        )
      );
    }
  }, [teacherSchools]);

  const handleSchoolChange = (e) => {
    if (!e?.value || e?.value === undefined) {
      setSelectedSchool("");
      setClassOption([]);
      return;
    }
    setSelectedSchool(e?.value);

    const fetchClasses = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllClasses?schoolId=${e?.value}&schoolYear=${schoolYear}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          alert("Errore durante il caricamento delle classi");
          console.error("Error fetching classes:", result.error);
          return;
        }
        setClassOption(
          customConvertIntoSelect2OptionsClasses(
            result,
            "idclassi",
            "classe",
            "sezione"
          )
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchClasses();
  };

  const handleSchoolChangeFromUrl = (id) => {
    const fetchClasses = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllClasses?schoolId=${id}&schoolYear=${schoolYear}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          alert("Errore durante il caricamento delle classi");
          console.error("Error fetching classes:", result.error);
          return;
        }
        setClassOption(
          customConvertIntoSelect2OptionsClasses(
            result,
            "idclassi",
            "classe",
            "sezione"
          )
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchClasses();
  };

  const handleClassChange = (e) => {
    setSelectedClass(e?.value);
    console.log("Selected class:", e?.value);
  };

  const handleNewStudent = () => {
    window.location.href = `/students/add?schoolId=${
      selectedSchool || ""
    }&classId=${selectedClass || ""}`;
  };

  const handleSearch = (classIdFromUrl = null) => {
    let classid;
    if (
      classIdFromUrl &&
      typeof classIdFromUrl === "object" &&
      classIdFromUrl.preventDefault
    ) {
      classid = selectedClass;
    } else {
      classid = classIdFromUrl || selectedClass;
    }

    if (!classid) {
      alert("Seleziona una classe");
      setStudents([]);
      return;
    }

    const fetchStudents = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/studente/byClass?idclass=${classid}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          alert("Nessun studente trovato");
          setStudents([]);
          return;
        }
        setStudents(
          result.return.studenti.filter((student) => {
            return student.isDisabled === "N";
          })
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchStudents();
  };

  const openModal = (student) => {
    setSelectedStudent(student);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleAcceptPolicy = (studentId) => {
    const fetchOptions = getFetchOptions(
      "application/x-www-form-urlencoded",
      [],
      "PUT"
    );
    fetch(
      `${axios.defaults.baseBFFUrl}/fe/acceptStudentPolicy?studentId=${studentId}`,
      fetchOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.status === "OK") {
          alert(data.message);
          closeModal();
        } else {
          alert(data.message);
        }
      })
      .catch((error) => console.error(error));
  };

  const handleDisableStudent = async (studentId) => {
    const fetchOptions = getFetchOptions("application/json", [], "DELETE");

    const response = await fetch(
      `${axios.defaults.baseBFFUrl}/fe/disableStudent?studentId=${studentId}`,
      fetchOptions
    );

    const result = await response.json();
    if (result.error) {
      alert("Errore durante la disabilitazione dello studente");
      console.error("Error disabling student:", result.error);
      return;
    }

    window.location.reload();
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      {/* Filters */}
      <div className="card custom-card">
        <div className="card-header">Scuola e classe</div>
        <div className="card-body">
          <div className="row align-items-end">
            <div className="col-12 col-xl-7">
              <Select
                options={schoolOptions}
                id="school"
                name="school"
                value={schoolOptions?.filter(function (option) {
                  return option.value == selectedSchool;
                })}
                onChange={handleSchoolChange}
                classNames={"form-control"}
                placeholder="Scegli scuola..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col-12 col-xl-3">
              <Select
                options={classOption}
                id="classe"
                name="classe"
                value={classOption?.filter(function (option) {
                  return option.value == selectedClass;
                })}
                onChange={handleClassChange}
                classNames={"form-control"}
                placeholder="Scegli classe..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col-12 col-xl-2">
              <button
                id="btnSearch"
                name="btnSearch"
                className="btn btn-success searchButton"
                type="button"
                onClick={handleSearch}
              >
                &nbsp;Cerca
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Students List */}
      <div className="card custom-card">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>Elenco studenti</div>
            <div>
              <div className="d-flex justify-content-end">
                <button
                  onClick={handleNewStudent}
                  type="button"
                  className="btn btn-primary text-uppercase"
                >
                  <i className="bi bi-plus-circle-fill"></i> Nuovo
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Cognome</th>
                  <th>Codice Fiscale</th>
                  <th>Email</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {students?.map((student, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{student.nome}</td>
                    <td>{student.cognome}</td>
                    <td>{student.codicefiscale}</td>
                    <td>{student.email}</td>
                    <td className="btn-list">
                      <div className="btn-list">
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() =>
                            (window.location.href = `/students/edit/${student.id}`)
                          }
                        >
                          <i className="align-middle bi bi-pencil"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDisableStudent(student.id)}
                        >
                          <i className="align-middle bi bi-trash"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-info"
                          onClick={() =>
                            (window.location.href = `/students/detail/${student.id}`)
                          }
                        >
                          <i className="align-middle bi bi-eye"></i>
                        </button>
                        <button
                          title="Accetta le politiche sulla privacy"
                          className="btn btn-sm btn-secondary"
                          onClick={() => openModal(student)}
                        >
                          <i className="align-middle bi bi-check-circle"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {modalOpen && selectedStudent && (
        <div className="modal-backdrop-custom">
          <div className="custom-modal">
            <div className="modal-header">
              <h5 className="modal-title">
                Politiche sulla privacy {selectedStudent.nome}{" "}
                {selectedStudent.cognome}
              </h5>
              <button type="button" className="close" onClick={closeModal}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="text-center text-muted">
                Cliccando su <b>Accetta</b> accetterai i termini e le condizioni
                espresse nei link sottostanti
              </p>
              <ul className="list-unstyled text-center">
                <li>
                  <a
                    href="https://cooltorial.it/privacy-e-note-legali/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "blue" }}
                  >
                    Politica sulla privacy (maggiorenni)
                  </a>
                </li>
                <li>
                  <a
                    href="https://cooltorial.it/home/informativa-privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "blue" }}
                  >
                    Politica sulla privacy (minori)
                  </a>
                </li>
              </ul>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleAcceptPolicy(selectedStudent.id);
                }}
              >
                Conferma accettazione
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentsLayout;
